import { connect, ConnectedProps } from 'react-redux'

import GroupHeader from 'components/accordion/GroupHeader'
import { setAccordionUrlNode } from 'redux/actions'
import { RootState, AppDispatch } from 'redux/store'

const mapStateToProps = (state: RootState): { flavour: RootState['layout']['flavour'], urlNode: RootState['accordion']['urlNode'], controller: RootState['layout']['controller'], pageData: RootState['layout']['pageData'], isMobile: boolean, headerHeight: RootState['layout']['headerHeight'], pageId: RootState['layout']['pageId'], sectionId: RootState['accordion']['sectionId'] } => ({
  flavour: state.layout.flavour,
  urlNode: state.accordion.urlNode,
  controller: state.layout.controller,
  pageData: state.layout.pageData,
  isMobile: state.layout.deviceType.isMobile,
  headerHeight: state.layout.headerHeight,
  pageId: state.layout.pageId,
  sectionId: state.accordion.sectionId
})

const mapDispatchToProps = (dispatch: AppDispatch): { setAccordionUrlNode: (urlNode: string) => ReturnType<AppDispatch> } => ({
  setAccordionUrlNode: (urlNode: string) => dispatch(setAccordionUrlNode(urlNode))
})

export const connector = connect(mapStateToProps, mapDispatchToProps)
export type GroupHeaderContainerProps = ConnectedProps<typeof connector>

export default connector(GroupHeader)
